module.exports = __webpack_public_path__ + "1.5.0-unryo/img/slack.610b83af.png";